export default __webpack_public_path__ + "static/media/uv3.5be3a924.svg";